import { EServiceId } from './serviceId';
import { EServiceType } from './serviceType';
import { EPromotionType } from './promotionType';
import { IServicePeriod } from './periods';

export interface IPublishTermsService {
  /** Идентификатор услуги */
  id: EServiceId;
  /** Название тарифа */
  name: string;
  /** Необходима идентификация пользователя */
  identificationRequired: boolean;
  /** Причина недоступности тарифа */
  unavailableReasonType: EUnavailableReason | null;
  /** Является дополнительным */
  isAdditional: boolean;
  /** Список несовместимых сервисов для текущего */
  incompatibleServices: Array<EServiceType>;
  /** Является тарифом по-умолчанию */
  isDefault: boolean;
  /** Доступна ли автопролонгация у тарифа */
  isAutoProlongAvailable: boolean;
  /** Количество доступных действий, сколько типов размещения можно купить */
  availableActionsCount: number;
  /** Типы услуги */
  services: Array<EServiceType>;
  /** Доступен ли тариф в данном случае */
  isAvailable: boolean;
  /** Уникальный ключ тарифа */
  key: string;
  /** Базовая ставка услуги */
  baseAuctionBet: number | null;
  /** Тип продвижения */
  promotionType: EPromotionType;
  period: IServicePeriod;
}

export enum EUnavailableReason {
  /** Для ТОП-3 нужны фото **/
  'NoPhotos' = 'noPhotos',
  /** Не выполнены условия необходимые для размещения объявлений в ТОП 3 **/
  'Top3ServiceDenied' = 'top3ServiceDenied',
  /** Возможность продвижения объявлений для Вашего аккаунта заблокирована администрацией **/
  'DeniedBySanctions' = 'deniedBySanctions',
  /** Доступно после окончания периода публикации Премиум **/
  'OnlyAfterPremiumServiceExpiration' = 'onlyAfterPremiumServiceExpiration',
  /** Нет доступных услуг **/
  'NoServicesAvailable' = 'noServicesAvailable',
  /** Недостаточно денег **/
  'NotEnoughMoney' = 'notEnoughMoney',
  /** Возможность создания бесплатных объявлений для Вашего аккаунта заблокирована администрацией **/
  'FreeServiceDenied' = 'freeServiceDenied',
  /** Возможность создания объявлений с выделением цветом для Вашего аккаунта заблокирована администрацией **/
  'HighlightServiceDenied' = 'highlightServiceDenied',
  /** Недостаточно средств для оплату у агентства **/
  'NotEnoughMoneyOnAgencyAccount' = 'notEnoughMoneyOnAgencyAccount',
  /** Исчерпан лимит объявлений для субагента **/
  'SubAgentLimitExceeded' = 'subAgentLimitExceeded',
  /** Когда у субагента есть запрет на топ и премиум **/
  'DeniedByMaster' = 'deniedByMaster',
}
